module.exports = __webpack_public_path__ + "static/media/fan-table.fbd6c6fb.svg";